(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advent-calendar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DONE = new WeakSet();
  var RX = /^\d{4}-\d{2}-\d{2}$/;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sub(str, o) { return String(str || '').replace(/\{(\w+)\}/g, function (_, k) { return o[k] != null ? o[k] : ''; }); }

  function init(root) {
    if (!root || DONE.has(root)) return;
    var src = root.querySelector('.adv-data'); if (!src) return;
    DONE.add(root);
    var data = JSON.parse(src.getAttribute('data-json'));
    var L = data.labels, tz = data.tz || 'America/Toronto', loc = String(data.locale || 'en');
    if (loc.indexOf('-') < 0) loc += '-CA';
    try { new Intl.DateTimeFormat(loc); } catch (e) { loc = 'en-CA'; }
    var bySort = function (k) { return function (a, b) { return a[k] < b[k] ? -1 : 1; }; };
    var doors = data.blocks.filter(function (b) { return b.type === 'door' && RX.test(b.date); }).sort(bySort('date'));
    var weeks = data.blocks.filter(function (b) { return b.type === 'week' && RX.test(b.start); }).sort(bySort('start'));
    var wkends = data.blocks.filter(function (b) { return b.type === 'weekend' && RX.test(b.start) && RX.test(b.end); });
    var N = doors.length;
    if (!N) { if (data.design) { root.hidden = false; root.innerHTML = '<p style="text-align:center">Advent calendar: add Door blocks with a date (YYYY-MM-DD).</p>'; } return; }

    function toD(s) { var p = s.split('-'); return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2], 12)); }
    function fmt(s, o) { o.timeZone = 'UTC'; return new Intl.DateTimeFormat(loc, o).format(toD(s)); }
    function fDate(s) { return fmt(s, { weekday: 'short', month: 'short', day: 'numeric' }); }
    function fDow(s) { return fmt(s, { weekday: 'short' }); }
    function fRange(a, b) {
      var f = new Intl.DateTimeFormat(loc, { month: 'short', day: 'numeric', timeZone: 'UTC' });
      if (a === b) return f.format(toD(a));
      return f.formatRange ? f.formatRange(toD(a), toD(b)) : f.format(toD(a)) + ' – ' + f.format(toD(b));
    }
    function nowParts() {
      var p = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return p;
    }
    function realToday() { var p = nowParts(); return p.year + '-' + p.month + '-' + p.day; }
    function cd() {
      var p = nowParts(), s = 86400 - (+p.hour * 3600 + +p.minute * 60 + +p.second);
      return [Math.floor(s / 3600), Math.floor(s % 3600 / 60), s % 60].map(function (v) { return String(v).padStart(2, '0'); }).join(':');
    }
    var qs = new URLSearchParams(location.search).get('calendar_date');
    var today = qs && RX.test(qs) ? qs : (data.design && RX.test(data.preview) ? data.preview : realToday());
    var expanded = data.layout === 'full', openWk = null;
    function isOpened(d) { try { return localStorage.getItem('adv-open-' + d) === '1'; } catch (e) { return false; } }
    function setOpened(d) { try { localStorage.setItem('adv-open-' + d, '1'); } catch (e) {} }

    // group doors into weeks
    var groups = weeks.length ? weeks.map(function (w, i) {
      var next = weeks[i + 1] ? weeks[i + 1].start : '9999';
      var ds = doors.filter(function (d) { return (i === 0 ? true : d.date >= w.start) && d.date < next; });
      return { headline: w.headline, doors: ds };
    }).filter(function (g) { return g.doors.length; }) : [{ headline: '', doors: doors }];

    function phase() {
      if (today < doors[0].date) return 'before';
      if ((RX.test(data.bfDate) && today >= data.bfDate) || today > doors[N - 1].date) return 'bf';
      return 'live';
    }

    var O = data.opts || {};
    var LOCK = '<svg class="adv-lock" viewBox="0 0 16 18" width="14" height="16" aria-hidden="true"><rect x="2" y="8" width="12" height="9" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M5 8V5.5a3 3 0 0 1 6 0V8" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';

    // Live price (theme pricing snippet) if a hero product is set, else the offer text.
    function priceOf(d) { var el = root.querySelector('[data-price-for="' + d.id + '"]'); return el ? el.innerHTML : ''; }
    function offerHTML(d, cls) { var p = priceOf(d); return p ? '<span class="adv-price ' + (cls || '') + '">' + p + '</span>' : '<span class="' + (cls || '') + '">' + esc(d.offer) + '</span>'; }

    // Minimal text per door: number + one short line.
    function doorHTML(d) {
      var hl = d.highlight ? ' hl' : '', n = +d.date.slice(8);
      var tag = d.highlight && d.badge ? '<span class="adv-tag">' + esc(d.badge) + '</span>' : '';
      var num = '<div class="adv-num">' + n + '</div>';
      if (d.date < today) return '<div class="adv-door past' + hl + '">' + num + '<div>' +
        (O.missedDeals ? '<b>' + esc(d.title) + '</b><small>' + esc(d.offer) + '</small>' : '') + '<em>' + esc(L.missed) + '</em></div></div>';
      if (d.date === today) {
        var img = O.todayImage && d.image;
        if (img) { num = '<div class="adv-door-img" style="background-image:url(&quot;' + esc(d.image) + '&quot;)">' + num + '</div>'; hl += ' has-img'; }
        return isOpened(d.date)
          ? '<a class="adv-door today opened' + hl + '" href="' + esc(d.link || '#') + '">' + tag + num + '<div><b>' + esc(d.title) + '</b><small>' + offerHTML(d) + '</small></div></a>'
          : '<button type="button" class="adv-door today' + hl + '" data-open="' + d.date + '">' + tag + num + '<div><b>' + esc(L.open) + '</b><small>' + esc(L.ends) + ' <span class="adv-t">' + cd() + '</span></small></div></button>';
      }
      return '<div class="adv-door future' + hl + '">' + tag + num + '<div>' + (O.teasers && d.teaser ? '<small>' + esc(d.teaser) + '</small>' : '') + LOCK + '</div></div>';
    }

    // Strip: progress · today's deal · countdown · button.
    function renderStrip(ph) {
      var el = root.querySelector('.adv-strip');
      if (ph === 'bf') {
        el.innerHTML = '<div class="adv-strip-in"><div class="adv-deal"><b>' + esc(L.bfTitle) + '</b></div><div class="adv-acts"><a class="adv-btn" href="' + esc(data.bfLink || '#') + '">' + esc(L.bfButton) + '</a></div></div>';
        return;
      }
      var past = doors.filter(function (d) { return d.date <= today; }).length;
      var cur = doors.find(function (d) { return d.date === today; });
      var nx = doors.find(function (d) { return d.date > today; });
      el.innerHTML = '<div class="adv-strip-in">' +
        '<div class="adv-day"><span>' + esc(sub(L.day, { n: past, total: N })) + '</span><div class="adv-track"><div class="adv-fill" style="width:' + (past / N * 100) + '%"></div></div></div>' +
        '<div class="adv-deal">' + (cur && O.todayImage && cur.image ? '<a class="adv-deal-img" href="' + esc(cur.link || '#') + '" style="background-image:url(&quot;' + esc(cur.image) + '&quot;)"></a>' : '') + '<div>' + (cur ? '<b>' + esc(cur.title) + '</b>' + offerHTML(cur, 'o') : '') +
          (O.tomorrow ? '<span class="adv-tmr">' + LOCK + ' ' + esc(L.tomorrow) + ': ' + esc(nx ? nx.teaser : L.bfTeaser) + '</span>' : '') + '</div></div>' +
        '<div class="adv-acts">' + (cur ? '<span class="adv-c">' + esc(L.ends) + ' <span class="adv-t">' + cd() + '</span></span><a class="adv-btn" href="' + esc(cur.link || '#') + '">' + esc(L.shop) + '</a>' : '') +
        '<button type="button" class="adv-link adv-toggle">' + esc(expanded ? L.hideAll : L.seeAll) + '</button></div></div>';
    }

    function render() {
      var ph = phase();
      if (ph === 'before' && !data.design) { root.hidden = true; return; }
      root.hidden = false;
      root.classList.toggle('is-expanded', expanded);
      renderStrip(ph);
      var we = wkends.find(function (w) { return today >= w.start && today <= w.end; });
      var weEl = root.querySelector('.adv-weekend');
      if (!O.weekend) we = null;
      weEl.hidden = !we; weEl.innerHTML = we ? '<b>' + esc(L.weekend) + '</b> ' + esc(we.text) : '';
      if (openWk === null) openWk = groups.findIndex(function (g) { return today >= g.doors[0].date && today <= g.doors[g.doors.length - 1].date; });
      root.querySelector('.adv-acc').innerHTML = groups.map(function (g, i) {
        var a = g.doors[0].date, b = g.doors[g.doors.length - 1].date;
        var st = today > b ? '<span class="adv-st done">' + esc(L.ended) + '</span>' : today >= a ? '<span class="adv-st now">' + esc(L.thisWeek) + '</span>' : '';
        return '<div class="adv-wk' + (i === openWk ? ' open' : '') + '"><button type="button" class="adv-wh" data-i="' + i + '"><span class="adv-wn">' + esc(sub(L.week, { n: i + 1 })) + '</span><span class="adv-wd">' + esc(fRange(a, b)) + '</span><span class="adv-ws">' + (O.headlines ? esc(g.headline) : '') + '</span>' + st + '<span class="adv-chev">+</span></button>' +
          '<div class="adv-wb"><div><div class="adv-doors">' + g.doors.map(doorHTML).join('') + '</div></div></div></div>';
      }).join('') + '<div class="adv-bfbar">' + esc(ph === 'bf' ? L.bfTitle : L.bfUpcoming) + '</div>';
    }

    function openDoor(date) {
      var d = doors.find(function (x) { return x.date === date; }); if (!d) return;
      var m = root.querySelector('.adv-modal');
      m.querySelector('.adv-img').style.backgroundImage = d.image ? 'url("' + d.image + '")' : '';
      m.querySelector('.adv-img').hidden = !d.image;
      m.querySelector('.adv-m-date').textContent = fDate(d.date) + (d.badge ? ' · ' + d.badge : '');
      m.querySelector('.adv-m-title').textContent = d.title;
      m.querySelector('.adv-m-off').innerHTML = offerHTML(d);
      m.querySelector('.adv-m-cd').textContent = L.ends + ' ' + cd();
      m.querySelector('.adv-m-link').href = d.link || '#';
      m.hidden = false; setOpened(d.date);
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var wh = t.closest('.adv-wh'); if (wh) { var i = +wh.dataset.i; openWk = openWk === i ? -1 : i; render(); return; }
      var od = t.closest('[data-open]'); if (od) { openDoor(od.dataset.open); return; }
      if (t.closest('.adv-toggle')) { expanded = !expanded; render(); return; }
      if (t.closest('.adv-x') || t.classList.contains('adv-modal')) { root.querySelector('.adv-modal').hidden = true; render(); }
    });

    // Theme editor: selecting a Door block previews that day
    document.addEventListener('shopify:block:select', function (e) {
      if (!e.detail || e.detail.sectionId !== data.sectionId) return;
      var d = doors.find(function (x) { return x.id === e.detail.blockId; });
      if (d) { today = d.date; openWk = null; expanded = true; render(); }
    });

    setInterval(function () { root.querySelectorAll('.adv-t').forEach(function (s) { s.textContent = cd(); }); }, 1000);
    render();
  }

  function initAll() { document.querySelectorAll('.adv-cal').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  window.addEventListener('load', initAll);
  // Re-init if the theme (Vue) re-renders the page after load
  var pend = false;
  new MutationObserver(function () { if (pend) return; pend = true; requestAnimationFrame(function () { pend = false; initAll(); }); }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('.adv-cal')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    static observedAttributes = ['aria-hidden'];

    constructor() {
      super();
      this.storageKey = this.dataset.storageKey || 'announcement-closed';
      this.ariaHidden = window.sessionStorage.getItem(this.storageKey) !== null;
    }

    connectedCallback() {
      this.querySelectorAll('[data-close]').forEach((closeElement) => {
        closeElement.addEventListener('click', () => {
          const cssRoot = document.querySelector(':root');
          cssRoot.style.setProperty('--announcement-bar-height', '0px');
          closeElement.blur(); // For accessibility
          this.ariaHidden = true;

          const customEvent = new CustomEvent('announcementClosed', {
            detail: { message: 'Announcement bar closed' },
          });

          // Dispatch the custom event
          closeElement.dispatchEvent(customEvent);
        });
      });
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'aria-hidden') {
        try {
          if (newValue === 'true') {
            window.sessionStorage.setItem(this.storageKey, true);
          } else {
            window.sessionStorage.removeItem(this.storageKey);
          }
        } catch (error) {
          window.console.warn(error);
        }
      }
    }
  }
  window.customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-centrepieces"] && !Shopify.designMode) return;
  try {
    
/* Bouclair Holiday Shop – accessible tabs (no dependencies) */
(function () {
  function select(tabs, tab, focus) {
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
    if (focus) tab.focus();
    var bar = tab.parentElement;
    if (bar && bar.scrollWidth > bar.clientWidth) {
      bar.scrollTo({ left: tab.offsetLeft - 16, behavior: 'smooth' });
    }
  }
  function init(root) {
    (root || document).querySelectorAll('[data-hs-tabs]').forEach(function (bar) {
      if (bar.dataset.hsReady) return;
      bar.dataset.hsReady = '1';
      var tabs = Array.prototype.slice.call(bar.querySelectorAll('[role="tab"]'));
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tabs, tab); });
        tab.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') n = tabs[0];
          if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(tabs, n, true); }
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var t = document.querySelector('[aria-controls="' + (e.target && e.target.id) + '"]');
    if (t) t.click();
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-gift-guide"] && !Shopify.designMode) return;
  try {
    
/* Bouclair Holiday Shop – accessible tabs (no dependencies) */
(function () {
  function select(tabs, tab, focus) {
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
    if (focus) tab.focus();
    var bar = tab.parentElement;
    if (bar && bar.scrollWidth > bar.clientWidth) {
      bar.scrollTo({ left: tab.offsetLeft - 16, behavior: 'smooth' });
    }
  }
  function init(root) {
    (root || document).querySelectorAll('[data-hs-tabs]').forEach(function (bar) {
      if (bar.dataset.hsReady) return;
      bar.dataset.hsReady = '1';
      var tabs = Array.prototype.slice.call(bar.querySelectorAll('[role="tab"]'));
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tabs, tab); });
        tab.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') n = tabs[0];
          if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(tabs, n, true); }
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var t = document.querySelector('[aria-controls="' + (e.target && e.target.id) + '"]');
    if (t) t.click();
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-strip"] && !Shopify.designMode) return;
  try {
    
  const PROMO_STRIP_LAYOUT_EVENT = 'promo-strip:layout-change';

  const normalizeGeoTargetValue = (value = '') => value.toString().trim().toUpperCase();
  const normalizeGeoTargetPostalCode = (value = '') => normalizeGeoTargetValue(value).replace(/[^A-Z0-9]/g, '');

  const parseGeoTargetValueList = (value = '') =>
    value
      .split(/\r?\n|,/)
      .map((entry) => normalizeGeoTargetValue(entry))
      .filter(Boolean);

  const parseGeoTargetPostalValueList = (value = '') =>
    value
      .split(/\r?\n|,/)
      .map((entry) => normalizeGeoTargetPostalCode(entry).slice(0, 3))
      .filter(Boolean);

  const buildPromoStripGeoCandidates = (geo = {}) => {
    const countryCode = normalizeGeoTargetValue(geo.countryCode);
    const countryName = normalizeGeoTargetValue(geo.countryName);
    const regionCode = normalizeGeoTargetValue(geo.regionCode);
    const regionName = normalizeGeoTargetValue(geo.regionName);

    const candidates = new Set([countryCode, countryName, regionCode, regionName].filter(Boolean));

    if (countryCode && regionCode) {
      candidates.add(`${countryCode}-${regionCode}`);
    }

    if (countryCode && regionName) {
      candidates.add(`${countryCode}-${regionName}`);
    }

    if (countryName && regionCode) {
      candidates.add(`${countryName}-${regionCode}`);
    }

    if (countryName && regionName) {
      candidates.add(`${countryName}-${regionName}`);
    }

    return candidates;
  };

  const slideHasGeoTarget = (slide) =>
    Boolean(
      slide.dataset.geoTargetRegionValues || slide.dataset.geoTargetCityValues || slide.dataset.geoTargetPostalPrefixes
    );

  const matchesPromoStripGeo = (slide, geo) => {
    const regionValues = parseGeoTargetValueList(slide.dataset.geoTargetRegionValues || '');
    const cityValues = parseGeoTargetValueList(slide.dataset.geoTargetCityValues || '');
    const postalPrefixes = parseGeoTargetPostalValueList(slide.dataset.geoTargetPostalPrefixes || '');

    if (!regionValues.length && !cityValues.length && !postalPrefixes.length) {
      return false;
    }

    const geoCandidates = buildPromoStripGeoCandidates(geo);

    if (!geoCandidates.size) {
      return false;
    }

    if (regionValues.length) {
      const hasRegionMatch = regionValues.some((entry) => geoCandidates.has(entry));

      if (!hasRegionMatch) {
        return false;
      }
    }

    if (cityValues.length) {
      const cityCandidate = normalizeGeoTargetValue(geo.city);

      if (!cityCandidate || !cityValues.includes(cityCandidate)) {
        return false;
      }
    }

    if (postalPrefixes.length) {
      const fsaCandidate = normalizeGeoTargetPostalCode(geo.fsa || geo.postalCode).slice(0, 3);

      if (!fsaCandidate || !postalPrefixes.includes(fsaCandidate)) {
        return false;
      }
    }

    return true;
  };

  class PromoStripSection extends HTMLElement {
    constructor() {
      super();
      this.currentSlide = 0;
      this.intervalId = null;
      this.headerElem = null;
      this.geoVisibleSlides = [];
      this.selectedSlide = null;
      this.stickyOffsetFrame = null;
      this.handleResize = this.handleResize.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.handleAnnouncementClosed = this.handleAnnouncementClosed.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
      this.handleVisitorGeoInitialized = this.handleVisitorGeoInitialized.bind(this);
      this.handleVisitorGeoReady = this.handleVisitorGeoReady.bind(this);
    }

    connectedCallback() {
      this.layout = this.dataset.layout;
      this.timerLength = Number(this.dataset.timerLength || 9) * 1000;
      this.stickyEnabled = this.dataset.sticky === 'true';
      this.stickyContainer = this.closest('.shopify-section') || this;
      this.headerElem = document.querySelector('[data-header]') || document.querySelector('header');
      this.desktopMediaQuery = window.matchMedia('(min-width: 750px)');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.loadingStrategy = this.dataset.geoTargetLoadingStrategy || 'show_default';
      this.previousControl = this.querySelector('[data-direction="previous"]');
      this.nextControl = this.querySelector('[data-direction="next"]');

      if (this.previousControl) {
        this.previousControl.addEventListener('click', () => this.goToPreviousSlide());
      }

      if (this.nextControl) {
        this.nextControl.addEventListener('click', () => this.goToNextSlide());
      }

      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

      this.renderInitialGeoState();
      this.refresh();
      this.resolveGeoTarget();

      window.addEventListener('resize', this.handleResize);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('announcementClosed', this.handleAnnouncementClosed, true);
      document.addEventListener(PROMO_STRIP_LAYOUT_EVENT, this.handleScroll);
      document.addEventListener('theme:visitor-geo:initialized', this.handleVisitorGeoInitialized);
      document.addEventListener('theme:visitor-geo:ready', this.handleVisitorGeoReady);
    }

    disconnectedCallback() {
      this.stopTimer();
      if (this.stickyOffsetFrame) {
        window.cancelAnimationFrame(this.stickyOffsetFrame);
        this.stickyOffsetFrame = null;
      }
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('announcementClosed', this.handleAnnouncementClosed, true);
      document.removeEventListener(PROMO_STRIP_LAYOUT_EVENT, this.handleScroll);
      document.removeEventListener('theme:visitor-geo:initialized', this.handleVisitorGeoInitialized);
      document.removeEventListener('theme:visitor-geo:ready', this.handleVisitorGeoReady);
      this.notifyLayoutChange();
    }

    get isDesktop() {
      return this.desktopMediaQuery.matches;
    }

    get visibleSlides() {
      if (this.selectedSlide) {
        return [this.selectedSlide];
      }

      return this.slides.filter((slide) => {
        const isGeoVisible = this.geoVisibleSlides.includes(slide);
        if (!isGeoVisible) return false;

        const devices = slide.dataset.devices || 'all';
        if (devices === 'all') return true;
        if (devices === 'desktop') return this.isDesktop;
        if (devices === 'mobile') return !this.isDesktop;
        return true;
      });
    }

    get defaultSlides() {
      return this.slides.filter((slide) => !slideHasGeoTarget(slide));
    }

    get targetedSlides() {
      return this.slides.filter((slide) => slideHasGeoTarget(slide));
    }

    getPreviewGeo() {
      if (!window.Shopify?.designMode) {
        return null;
      }

      const previewRegion = this.dataset.geoTargetPreviewRegion || '';
      const previewCity = this.dataset.geoTargetPreviewCity || '';
      const previewFsa = normalizeGeoTargetPostalCode(this.dataset.geoTargetPreviewFsa || '').slice(0, 3);

      if (!previewRegion && !previewCity && !previewFsa) {
        return null;
      }

      return {
        countryCode: 'CA',
        regionCode: previewRegion,
        regionName: previewRegion,
        city: previewCity,
        fsa: previewFsa,
        postalCode: previewFsa,
      };
    }

    handleBlockSelect(event) {
      const selectedSlide = event.target.closest('[data-slide]');

      if (!selectedSlide || !this.contains(selectedSlide)) {
        return;
      }

      this.selectedSlide = selectedSlide;
      this.refresh();
    }

    handleBlockDeselect() {
      this.selectedSlide = null;
      this.refresh();
    }

    handleResize() {
      this.refresh();
    }

    handleScroll() {
      if (!this.stickyEnabled) return;
      this.scheduleStickyOffsetUpdate();
    }

    handleAnnouncementClosed() {
      if (!this.stickyEnabled) return;
      this.scheduleStickyOffsetUpdate();
    }

    handleVisitorGeoInitialized() {
      this.resolveGeoTarget();
    }

    handleVisitorGeoReady(event) {
      if (!event.detail || !this.targetedSlides.length) {
        return;
      }

      this.applyGeo(event.detail);
    }

    setGeoVisibleSlides(slides) {
      this.geoVisibleSlides = slides;
    }

    applyDefaultGeoState() {
      this.setGeoVisibleSlides(this.defaultSlides);
      this.refresh();
    }

    getResolvedSlides(matchedSlides = []) {
      if (!matchedSlides.length) {
        return this.defaultSlides;
      }

      return this.slides.filter((slide) => this.defaultSlides.includes(slide) || matchedSlides.includes(slide));
    }

    renderInitialGeoState() {
      if (!this.targetedSlides.length) {
        this.setGeoVisibleSlides(this.slides);
        return;
      }

      if (this.loadingStrategy === 'hide_until_resolved') {
        this.setGeoVisibleSlides([]);
        return;
      }

      this.setGeoVisibleSlides(this.defaultSlides);
    }

    applyGeo(geo) {
      const matchedSlides = this.targetedSlides.filter((slide) => matchesPromoStripGeo(slide, geo));

      this.setGeoVisibleSlides(this.getResolvedSlides(matchedSlides));

      this.refresh();
    }

    async resolveGeoTarget() {
      if (!this.targetedSlides.length) {
        return;
      }

      const previewGeo = this.getPreviewGeo();

      if (previewGeo) {
        this.applyGeo(previewGeo);
        return;
      }

      const visitorGeo = window.theme?.visitorGeo;

      if (!visitorGeo?.get || !visitorGeo?.getSync) {
        this.applyDefaultGeoState();
        return;
      }

      const cachedGeo = visitorGeo.getSync();

      if (cachedGeo) {
        this.applyGeo(cachedGeo);
        return;
      }

      const resolvedGeo = await visitorGeo.get();

      if (resolvedGeo) {
        this.applyGeo(resolvedGeo);
        return;
      }

      this.applyDefaultGeoState();
    }

    scheduleStickyOffsetUpdate() {
      if (this.stickyOffsetFrame) return;

      this.stickyOffsetFrame = window.requestAnimationFrame(() => {
        this.stickyOffsetFrame = null;
        this.updateStickyOffset();
      });
    }

    refresh() {
      const visibleSlides = this.visibleSlides;

      this.hidden = visibleSlides.length === 0;

      this.updateSlideVisibility(visibleSlides);
      this.updateStickyOffset();
      this.notifyLayoutChange();

      if (this.layout === 'inline') {
        this.stopTimer();
        return;
      }

      if (visibleSlides.length === 0) {
        this.stopTimer();
        return;
      }

      if (this.currentSlide >= visibleSlides.length) {
        this.currentSlide = 0;
      }

      this.renderActiveSlide(visibleSlides);

      if (this.layout === 'alternate_timer') {
        this.startTimer(visibleSlides);
      } else {
        this.stopTimer();
      }
    }

    updateSlideVisibility(visibleSlides = this.visibleSlides) {
      this.slides.forEach((slide) => {
        const isVisible = this.selectedSlide ? slide === this.selectedSlide : visibleSlides.includes(slide);
        slide.hidden = !isVisible;
        slide.classList.remove('is-active');
      });

      const controlsHidden = visibleSlides.length <= 1;
      if (this.previousControl) this.previousControl.hidden = controlsHidden;
      if (this.nextControl) this.nextControl.hidden = controlsHidden;
    }

    renderActiveSlide(visibleSlides = this.visibleSlides) {
      visibleSlides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === this.currentSlide);
      });
    }

    goToNextSlide() {
      const slides = this.visibleSlides;
      if (slides.length <= 1) return;
      this.currentSlide = (this.currentSlide + 1) % slides.length;
      this.renderActiveSlide();
    }

    goToPreviousSlide() {
      const slides = this.visibleSlides;
      if (slides.length <= 1) return;
      this.currentSlide = (this.currentSlide + slides.length - 1) % slides.length;
      this.renderActiveSlide();
    }

    startTimer(visibleSlides = this.visibleSlides) {
      this.stopTimer();
      if (visibleSlides.length <= 1) return;
      this.intervalId = window.setInterval(() => this.goToNextSlide(), this.timerLength);
    }

    stopTimer() {
      if (this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    get precedingStickyStripsHeight() {
      return Array.from(document.querySelectorAll('promo-strip-section'))
        .filter(
          (strip) =>
            strip !== this &&
            strip.dataset.sticky === 'true' &&
            !strip.hidden &&
            this.compareDocumentPosition(strip) & Node.DOCUMENT_POSITION_PRECEDING
        )
        .reduce((total, strip) => total + strip.offsetHeight, 0);
    }

    notifyLayoutChange() {
      document.dispatchEvent(new CustomEvent(PROMO_STRIP_LAYOUT_EVENT));
    }

    updateStickyOffset() {
      if (!this.stickyEnabled) return;
      const headerElem = this.headerElem || document.querySelector('[data-header]') || document.querySelector('header');
      const headerHidden = headerElem ? headerElem.classList.contains('-translate-y-full') : false;
      const offset = headerElem && !headerHidden ? headerElem.offsetHeight + this.precedingStickyStripsHeight : 0;
      this.classList.toggle('promo-strip--hidden', headerHidden);
      this.stickyContainer.style.setProperty('--promo-strip-sticky-top', `${offset}px`);
    }
  }

  if (!window.customElements.get('promo-strip-section')) {
    window.customElements.define('promo-strip-section', PromoStripSection);
  }

  } catch(e) { console.error(e); }
})();
})();
